(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hf-store-header"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.hf-menu').forEach(menu=>{const summary=menu.querySelector('summary');menu.querySelectorAll('a').forEach(link=>link.addEventListener('click',()=>{menu.open=false}));document.addEventListener('keydown',event=>{if(event.key==='Escape'&&menu.open){menu.open=false;summary.focus()}});document.addEventListener('click',event=>{if(menu.open&&!menu.contains(event.target)){menu.open=false}})});
  } catch(e) { console.error(e); }
})();

})();
